import * as z from "zod/v4";
import { VariantAnalyticsFilterSchema } from "./filters/analytics-filter";
import { ViewByEnum, ViewByToggleSchema } from "./filters/view-by-toggle";
import {
  ProductSchema,
  VariantSchema,
  VariantSortSchema,
} from "./product-analytics.types";

// Input schema for variant analytics
export const VariantAnalyticsInputSchema = z.object({
  productId: z.string(),
  sort: VariantSortSchema.nullish(),
  filters: z
    .array(VariantAnalyticsFilterSchema)
    .nullish()
    .describe(
      "Filters to apply to the variant analytics. When used by an agent, be sure to ask the user for clarification on what the filters should be set to.",
    ),
  viewBy: ViewByToggleSchema.default(ViewByEnum.ORDER_DATE).describe(
    "Whether to view analytics by order date or processed date",
  ),
});

// Output schema for variant analytics
export const VariantAnalyticsOutputSchema = z
  .object({ product: ProductSchema, variants: z.array(VariantSchema) })
  .describe(
    "Variant-level analytics give you a more precise view of product performance by allowing you to filter and evaluate individual styles, sizes, or colors. Tracking return and exchange rates, alongside quantity sold and return value, helps you spot specific variants that may be causing issues—like sizing inconsistencies or quality concerns. This level of detail enables smarter merchandising decisions, more accurate forecasting, and targeted improvements to product listings. By understanding which variants lead to returns and why, you can reduce costs, enhance the customer experience, and optimize your inventory strategy.",
  );

// Export type definitions for TypeScript
export type VariantAnalyticsInput = z.infer<typeof VariantAnalyticsInputSchema>;
export type VariantAnalyticsOutput = z.infer<
  typeof VariantAnalyticsOutputSchema
>;

// Define the entire schema for RPC usage
export const getReturnAnalyticsByVariant = {
  input: VariantAnalyticsInputSchema,
  output: VariantAnalyticsOutputSchema,
};
